import { useState } from 'react';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { listNotificationKinds, type NotificationKind } from '@/lib/notificationSend.ts';

export interface NotificationKindChoice {
  kinds: UseQueryResult<NotificationKind[]>;
  kind: string;
  entry: NotificationKind | undefined;
  label: string;
  /** About the person rather than a meeting: no meeting to pick, and it goes to a list. */
  isUserScope: boolean;
  /** A canned mail: it only goes by email, and can be sent to someone again. */
  isEmail: boolean;
  choose: (kind: string) => void;
}

/** Which moment or mail is being sent; the first one until staff pick another. */
export function useNotificationKind(): NotificationKindChoice {
  const [chosenKind, setChosenKind] = useState('');

  const kinds = useQuery({
    queryKey: ['notificationKinds'],
    queryFn: listNotificationKinds,
  });

  const kind = chosenKind === '' ? (kinds.data?.[0]?.kind ?? '') : chosenKind;
  const entry = kinds.data?.find((option) => option.kind === kind);

  return {
    kinds,
    kind,
    entry,
    label: entry?.label ?? '',
    isUserScope: entry?.scope === 'user',
    isEmail: entry?.group === 'email',
    choose: setChosenKind,
  };
}
